import React from "react";
import shape1 from "../../assets/special1.svg";
import shape2 from "../../assets/special2.svg";
import shape3 from "../../assets/special3.svg";

const Special = () => {
  const data = [
    {
      img: shape1,
      text: "We offer unmatched resources to help even the most unexperienced entrepreneurs and founders the world over.",
    },
    {
      img: shape2,
      text: "We create unparalleled opportunities that offer you the greatest chances for growth & success.",
    },
    {
      img: shape1,
      text: "We support founders from the early stages of their startup throughout their journey to becoming established entrepreneurs with guidance, funding, & everything in between.",
    },
  ];

  return (
   <section className="w-full bg-white px-3 py-12 lg:px-0 lg:py-20 text-center">
      {/* Heading */}
      <div className="px-6 md:px-36">
            <h3 className="relative text-3xl md:text-4xl font-light text-gray-800 text-left">
              What makes <br />
              us <span className="text-[#02C4A1]">special?</span>
            </h3>
          </div>

      {/* Container grid */}
      <div className="flex flex-col w-full lg:flex-row lg:justify-between items-center  gap-6 sm:gap-8">
        {data.map((item, idx) => (
          <div
            key={idx}
            className={`relative w-[100%]  xs:w-[80%] md:w-[60%] lg:w-[33%] h-[45vh] xs:h-[50vh] sm:h-[50vh] md:h-[52vh] lg:h-[50vh] flex items-center justify-center text-center  ${idx === 0 ? 'mt-0' : idx === 1 ? '-mt-0' : '-mt-24'}  ${ idx === 2 ? 'sm:-mt-24' : 'sm:-mt-2'} lg:-mt-0 `}
          >
            {/* SVG as background */}
            <img
              src={item.img}
              alt="Shape"
              className="absolute inset-0 w-full h-full object-cover xs:object-cover sm:object-cover"
            />
            <p className="relative z-10 max-w-[60%] text-gray-800 font-normal leading-relaxed px-6  text-xs md:text-sm">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};


export default Special;
